var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spnod-admin__form--container container mx-0 w-100",
    class: _vm.isMobile ? 'px-0' : 'px-3'
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-form-group', {
    staticClass: "mb-3"
  }, [_c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "name": "email",
      "state": _vm.validateState('email'),
      "type": "text",
      "placeholder": "Email",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.email.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.email, "$model", $$v)
      },
      expression: "$v.form.email.$model"
    }
  }), _vm._v(" "), _c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "name": "phone",
      "state": _vm.validateState('phone'),
      "type": "text",
      "placeholder": "Phone Number",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.phone.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.phone, "$model", $$v)
      },
      expression: "$v.form.phone.$model"
    }
  }), _vm._v(" "), (_vm.form.error !== '') ? _c('div', [_vm._v(_vm._s(this.form.error))]) : _vm._e()], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "submit",
      "size": "sm",
      "disabled": _vm.isDisabled
    }
  }, [(!_vm.isSending) ? _c('p', [_vm._v("Send")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2878cbb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/ResendCodeForm.vue
// module id = ZVjL
// module chunks = 2